import script from "./NextMilestoneCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NextMilestoneCard.vue?vue&type=script&setup=true&lang=ts"

import "./NextMilestoneCard.vue?vue&type=style&index=0&id=2958197c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2958197c"]])

export default __exports__